import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-pessoa-termo-lgpd-status-badge',
    templateUrl: './pessoa-termo-lgpd-status-badge.component.html',
    styleUrls: ['./pessoa-termo-lgpd-status-badge.component.less']
})
export class PessoaTermoLGPDStatusBadgeComponent {
    @Input() status: number;
}
